import { render, staticRenderFns } from "./RegisterSingleBuildingProjectBox.vue?vue&type=template&id=7be18eb6"
import script from "./RegisterSingleBuildingProjectBox.vue?vue&type=script&lang=js"
export * from "./RegisterSingleBuildingProjectBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports